import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  CREATEPROFILE_INIT_ACTION,
  CREATEPROFILE_FAIL_ACTION,
  CREATEPROFILE_SUCCESS_ACTION,
  FETCHSTATE_INIT_ACTION,
  FETCHSTATE_SUCCESS_ACTION,
  FETCHSTATE_FAIL_ACTION,
  FETCHDISTRICT_INIT_ACTION,
  FETCHDISTRICT_SUCCESS_ACTION,
  FETCHDISTRICT_FAIL_ACTION,
  FETCHBANKS_INIT_ACTION,
  FETCHBANKS_SUCCESS_ACTION,
  FETCHBANKS_FAIL_ACTION,
  FETCH_ORGPROFILE_INIT_ACTION,
  FETCH_ORGPROFILE_SUCCESS_ACTION,
  FETCH_ORGPROFILE_FAIL_ACTION
} from "./action";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import { push } from "connected-react-router";
import "react-toastify/dist/ReactToastify.css";

function* createOrgProfile(value) {
  // console.log(value);
  try {
    const token = localStorage.getItem("token");

    if(value.value.file) {
      const formdata = new FormData();
      formdata.append("name", value.value.file.name);
      formdata.append("file", value.value.file, "name");

      const res = yield fetch(`${appConfig.imgServerip}/addOrgImg`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formdata
      });

      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();

        const userId = JSON.parse(localStorage.getItem("userDetails")).id;
        const data = {
          userId: userId,
          type: "distributor",
          category: value.value.category,
          name: value.value.orgname,
          website: value.value.weburl,
          contactPersn: value.value.contPerson,
          email: value.value.storeEmail,
          gstin: value.value.gstin,
          licenceNo: value.value.licenceNo,
          drugLicense:value.value.licenceNo2,
          addr1: value.value.addr1,
          addr2: value.value.addr2,
          landmark: value.value.landmark,
          zip: value.value.zip,
          mobile: value.value.mobile,
          imgUrl: resJSON.files[0],
          country: "5f55e6b69e2b29e675c220b9",
          addr2: value.value.addr2,
          landmark: value.value.landmark,
          city: value.value.city,
          zip: value.value.zip,
          geo: value.value.geo,
          workingHrs:value.value.workingHrs,
          crdtPeriod: value.value.credit,
          state: value.value.states,
          district: value.value.district,
          bankName:value.value.bankName,
          acntName:value.value.acholderName,
          acntType:value.value.acType,
          acntNo:value.value.acNo,
          ifscCode:value.value.ifsc,
          brchName:value.value.branchName,
          brchAddr:value.value.branchAddr,
          lName: JSON.parse(localStorage.getItem("userDetails")).lName,
          uname: JSON.parse(localStorage.getItem("userDetails")).name
        };

        // console.log(data);

         const resUpdate = yield fetch(`${appConfig.ip}/orgProf`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(data)
        }); 
        // console.log(resUpdate);

        if (!resUpdate.ok) {
          throw resUpdate;
        } else {
          const resUpdateJSON = yield resUpdate.json();
          // console.log(resUpdateJSON);
          yield put({
            type: CREATEPROFILE_SUCCESS_ACTION,
            payload: resUpdateJSON
          });
          yield toast.success("Your profile is now created", {
            autoClose: 3000,
            transition:Flip
          });
          yield put(push("/dashboard"));
        }
      }
    }else{
      const userId = JSON.parse(localStorage.getItem("userDetails")).id;
        const data = {
          userId: userId,
          type: "distributor",
          category: value.value.category,
          name: value.value.orgname,
          website: value.value.weburl,
          contactPersn: value.value.contPerson,
          email: value.value.storeEmail,
          gstin: value.value.gstin,
          licenceNo: value.value.licenceNo,
          drugLicense:value.value.licenceNo2,
          addr1: value.value.addr1,
          addr2: value.value.addr2,
          landmark: value.value.landmark,
          zip: value.value.zip,
          mobile: value.value.mobile,
          country: "5f55e6b69e2b29e675c220b9",
          addr2: value.value.addr2,
          landmark: value.value.landmark,
          city: value.value.city,
          zip: value.value.zip,
          geo: value.value.geo,
          workingHrs:value.value.workingHrs,
          crdtPeriod: value.value.credit,
          state: value.value.states,
          district: value.value.district,
          bankName:value.value.bankName,
          acntName:value.value.acholderName,
          acntType:value.value.acType,
          acntNo:value.value.acNo,
          ifscCode:value.value.ifsc,
          brchName:value.value.branchName,
          brchAddr:value.value.branchAddr,
          lName: JSON.parse(localStorage.getItem("userDetails")).lName,
          uname: JSON.parse(localStorage.getItem("userDetails")).name
        };

        // console.log(data);

        const resUpdate = yield fetch(`${appConfig.ip}/orgProf`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(data)
        });
        // console.log(resUpdate);

         if (!resUpdate.ok) {
          throw resUpdate;
        } else {
          const resUpdateJSON = yield resUpdate.json();
          // console.log(resUpdateJSON);
          yield put({
            type: CREATEPROFILE_SUCCESS_ACTION,
            payload: resUpdateJSON
          });
          yield toast.success("Your profile is now created", {
            autoClose: 3000,
            transition:Flip
          });
          yield put(push("/dashboard"));
        } 
      }
  } catch (err) {
    if (err.status === 401) {
      yield toast.error("You are not permitted to do the action", {
        autoClose: 3000,
        transition:Flip
      });
    }

    yield put({
      type: CREATEPROFILE_FAIL_ACTION,
      payload: err
    });
  } 
}

function* fetchStates() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/state/all`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCHSTATE_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    yield put({
      type: FETCHSTATE_FAIL_ACTION,
      payload: err
    });
  }
}

function* fetchDistricts(val) {
  // console.log(val);
  try {
    const token = localStorage.getItem("token");
    const stateid = val.value;
    const res = yield fetch(`${appConfig.ip}/districts?stateId=${stateid}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    // console.log(res);
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCHDISTRICT_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    yield put({
      type: FETCHDISTRICT_FAIL_ACTION,
      payload: err
    });
  }
}

function* fetchbanks() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/bankName/all`, {//?sort=name- not working
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      },
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCHBANKS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    yield put({
      type: FETCHBANKS_FAIL_ACTION,
      payload: err
    });
  }
}

function* fetchOrgProfile(value) {
  try {
    const token = localStorage.getItem("token");
    const userId = value.value;
    const res = yield fetch(`${appConfig.ip}/orgProf/${userId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_ORGPROFILE_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    yield put({
      type: FETCH_ORGPROFILE_FAIL_ACTION,
      payload: err
    });
  }
}

export function* createProfileActionWatcher() {
  yield takeEvery(CREATEPROFILE_INIT_ACTION, createOrgProfile);
  yield takeEvery(FETCHSTATE_INIT_ACTION, fetchStates);
  yield takeEvery(FETCHDISTRICT_INIT_ACTION, fetchDistricts);
  yield takeEvery(FETCHBANKS_INIT_ACTION, fetchbanks);
  yield takeEvery(FETCH_ORGPROFILE_INIT_ACTION, fetchOrgProfile);
}
